import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["onClick", "children", "dataContentPiece"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { jsxs as l, jsx as r } from "react/jsx-runtime";
import { c as i } from "../clsx-OuTLNxxd.js";
import { useCallback as m } from "react";
import { Icon as _ } from "../Icon/Icon.js";
import { i as d } from "../checks-C6AyTTQ0.js";
const u = "PromoBadges-module_container__VVZsi",
  p = "PromoBadges-module_promo-icon__azH1j",
  f = "PromoBadges-module_inverted__H5Ksc",
  g = "PromoBadges-module_item__yVQbB",
  v = "PromoBadges-module_as-link__TA6Zw",
  B = "PromoBadges-module_container-small__9sTDb",
  t = {
    container: u,
    promoIcon: p,
    inverted: f,
    item: g,
    asLink: v,
    containerSmall: B
  },
  j = _ref => {
    let {
      className: e,
      promos: o,
      onPromoBadgeClicked: a,
      inverted: n = !1,
      variant: c = "normal"
    } = _ref;
    return o.length == 0 ? null : /* @__PURE__ */l("div", {
      className: i(t.container, e, {
        [t.containerSmall]: c == "small"
      }),
      children: [/* @__PURE__ */r(_, {
        name: "promo",
        className: i(t.promoIcon, {
          [t.inverted]: n
        }),
        size: "1x",
        padding: !1
      }), o.map(s => /* @__PURE__ */r(P, {
        promo: s,
        onPromoBadgeClicked: a,
        inverted: n
      }, s.code))]
    });
  },
  P = _ref2 => {
    let {
      promo: e,
      onPromoBadgeClicked: o,
      inverted: a
    } = _ref2;
    const n = m(() => o === null || o === void 0 ? void 0 : o(e.code), [o, e.code]);
    return /* @__PURE__ */r(b, {
      className: i(t.item, {
        [t.inverted]: a,
        [t.asLink]: d(o)
      }),
      onClick: o ? n : void 0,
      dataContentPiece: "promo_badge_click__".concat(e.code),
      children: e.title
    }, e.code);
  },
  b = _ref3 => {
    let {
        onClick: e,
        children: o,
        dataContentPiece: a
      } = _ref3,
      n = _objectWithoutProperties(_ref3, _excluded);
    const c = m(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    s => {
      e && (s.code == "Space" || s.code == "Enter") && e(s);
    }, [e]);
    return d(e) ? /* @__PURE__ */r("div", _objectSpread(_objectSpread({}, n), {}, {
      onClick: e,
      onKeyDown: c,
      tabIndex: 0,
      role: "button",
      "aria-pressed": "false",
      style: {
        cursor: "pointer"
      },
      "data-content-piece": a,
      children: o
    })) : /* @__PURE__ */r("div", _objectSpread(_objectSpread({}, n), {}, {
      children: o
    }));
  };
export { j as PromoBadges };